// メッセージMap
export const MessageMap = {
    "apply_date_start": "申込年月(開始)",
    "apply_date_end": "申込年月(終了)"
};